export default "__VITE_ASSET__BZDD7WE4__"